import React from 'react'
import More from './../../common/images/more.svg'
import Instagram from './../../common/images/instagram.svg'
import Facebook from './../../common/images/facebook.svg'
import Twitter from './../../common/images/twitter.svg'
import Linkedin from './../../common/images/linkedin.svg'

import { Row, Col } from 'react-bootstrap'
import { CardWrapper, StyledImage, StyledHeader, StyledTitle, StyledDate, FooterWrapper, SocialList, SocialListItem, StyledContent, StyledCardContent, StyledKeepReading } from './styled'
import { theme, formatDate } from './../../common'

const NewsCard = (props) => {
    return(    
        <CardWrapper>
            <StyledImage src={props.image.url}/>
            <StyledCardContent>
                <StyledHeader>
                    <StyledTitle>
                        {props.title}
                    </StyledTitle>
                    <StyledDate>
                        {formatDate(props.date)}
                    </StyledDate>
                </StyledHeader>
                <StyledContent dangerouslySetInnerHTML={{__html: props.content}}/>
            </StyledCardContent>
            <FooterWrapper>
                <StyledKeepReading>
                    {/* <p>Continuar lendo</p> */}
                    {/* <img src={More}/> */}
                </StyledKeepReading>
                <SocialList>
                    <a href={`https://twitter.com/intent/tweet?text=${encodeURI(`${props.title} https://fr-instalacoes.com.br/noticias`)}`} target="_blank">
                        <SocialListItem>
                            <img src={Twitter}/>
                        </SocialListItem>
                    </a>
                    <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A//fr-instalacoes.com.br/noticias">
                    <SocialListItem>
                        <img src={Facebook}/>
                    </SocialListItem>
                    </a>

                    <a href={`https://www.linkedin.com/shareArticle?&url=https://fr-instalacoes.com.br/noticias`} target="_blank">
                        <SocialListItem>
                            <img src={Linkedin}/>
                        </SocialListItem>
                    </a>

                    {/* <SocialListItem>
                        <img src={Instagram}/>
                    </SocialListItem> */}
                </SocialList>
            </FooterWrapper>
        </CardWrapper>
    )
}

export default NewsCard